module.exports = __webpack_public_path__ + "static/media/mobiledemo4.df81ed13.jpg";